import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaTag } from 'react-icons/fa';
import { NewsArticle } from '../pages/news';
import { convertRToSuperscript, truncateText } from '../utils/utils';
import GenericLink from './GenericLink';
import Img from 'gatsby-image/withIEPolyfill';
import ReadMoreLink from './ReadMoreLink';
import clsx from 'clsx';

import * as styles from './NewsCard.module.scss';

interface NewsCardProps {
  article: NewsArticle;
  date?: string;
  className?: string;
}

const NewsCard = ({ article, date, className }: NewsCardProps): React.ReactElement => {
  const { t } = useTranslation();

  return (
    <GenericLink
      noStyle
      to={`/news/${article.slug.current}`}
      className={clsx(styles.container, className)}
    >
      <article>
        {!!(article.image && article.image.asset) && (
          <Img className={styles.cardImage} fluid={article.image.asset.fluid} alt={article.title} />
        )}
        {article.categories.length > 0 && (
          <div className={styles.categoryContentTypeBar}>
            <FaTag className={styles.categoryIcon}></FaTag>
            <div className={styles.categoryTitleContainer}>
              {article.categories.map((category, i) => (
                <span key={i} className={styles.categoryTitle + ' titleParagraph'}>
                  {category.title}
                  {i < article.categories.length - 1 ? ',' : ''}
                </span>
              ))}
            </div>
          </div>
        )}
        <div className={styles.cardText}>
          <span className={styles.title} title={article.title}>
            {convertRToSuperscript(truncateText(article.title, 60))}
          </span>
          <span className={styles.date}>{date || article.date}</span>
          {!!article.extract && (
            <p className={styles.text}>
              {convertRToSuperscript(truncateText(article.extract, 200))}
            </p>
          )}
        </div>
        <ReadMoreLink styleOnly>{t('news_page.read_more_link', 'Read More')}</ReadMoreLink>
      </article>
    </GenericLink>
  );
};

export default NewsCard;
